import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

(function () {
    "use strict";

    function isMobile() {
        return window.matchMedia("(max-width: 766px)").matches;
    }

    function initOrDestroy(sectionEl) {
        var swiperEl = sectionEl.querySelector(".js-info-block-type-2");
        if (!swiperEl) return;

        var shouldInit = isMobile();
        var instance = swiperEl._swiperInstance || null;

        if (shouldInit && !instance) {
            swiperEl._swiperInstance = new Swiper(swiperEl, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.05,
                spaceBetween: 16,
                centeredSlides: false,
                watchOverflow: true,
                pagination: {
                    el: swiperEl.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.querySelector(".swiper-button-next"),
                    prevEl: swiperEl.querySelector(".swiper-button-prev"),
                },
            });

            return;
        }

        if (!shouldInit && instance) {
            instance.destroy(true, true);
            swiperEl._swiperInstance = null;
        }
    }

    function initAll() {
        document.querySelectorAll("[data-info-block-type-2]").forEach(function (sectionEl) {
            initOrDestroy(sectionEl);
        });
    }

    var t = null;
    function onResize() {
        window.clearTimeout(t);
        t = window.setTimeout(initAll, 150);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            initAll();
            window.addEventListener("resize", onResize);
            window.addEventListener("orientationchange", onResize);
        });
    } else {
        initAll();
        window.addEventListener("resize", onResize);
        window.addEventListener("orientationchange", onResize);
    }
})();